// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Components__HoverController from "./components/hover_controller"
application.register("components--hover", Components__HoverController)

import Carousel from "@stimulus-components/carousel"
application.register("carousel", Carousel)

import CommentLinkController from "./comment_link_controller"
application.register("comment-link", CommentLinkController)

import Components__FilterController from "./components/filter_controller"
application.register("components--filter", Components__FilterController)

import Components__KanbanColumnController from "./components/kanban_column_controller"
application.register("components--kanban-column", Components__KanbanColumnController)

import Components__KanbanCountController from "./components/kanban_count_controller"
application.register("components--kanban-count", Components__KanbanCountController)

import Components__KanbanGridController from "./components/kanban_grid_controller"
application.register("components--kanban-grid", Components__KanbanGridController)

import Components__KanbanLinkController from "./components/kanban_link_controller"
application.register("components--kanban-link", Components__KanbanLinkController)

import Components__ListCountController from "./components/list_count_controller"
application.register("components--list-count", Components__ListCountController)

import Components__ListSortController from "./components/list_sort_controller"
application.register("components--list-sort", Components__ListSortController)

import Components__SelectMenuController from "./components/select_menu_controller"
application.register("components--select-menu", Components__SelectMenuController)

import Components__SelectController from "./components/select_controller"
application.register("components--select", Components__SelectController)

import Components__TableSortController from "./components/table_sort_controller"
application.register("components--table-sort", Components__TableSortController)

import Components__TableCountController from "./components/table_count_controller"
application.register("components--table-count", Components__TableCountController)

import Components__ToggleController from "./components/toggle_controller"
application.register("components--toggle", Components__ToggleController)

import AccordionController from '@kanety/stimulus-accordion';
application.register('accordion', AccordionController);

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BirthdayController from "./birthday_controller"
application.register("birthday", BirthdayController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CacheCommentController from "./cache_comment_controller"
application.register("cache-comment", CacheCommentController)

import ChartjsController from "./chartjs_controller"
application.register("chartjs", ChartjsController)

import ClickableCellController from "./clickable_cell_controller"
application.register("clickable-cell", ClickableCellController)

import CodeBlockSelectorController from "./code_block_selector_controller"
application.register("code-block-selector", CodeBlockSelectorController)

import DailyCalcController from "./daily_calc_controller"
application.register("daily-calc", DailyCalcController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import EntryTriggerController from "./entry_trigger_controller"
application.register("entry-trigger",EntryTriggerController)

import LetterDatatableController from "./letter_datatable_controller"
application.register("letter-datatable", LetterDatatableController)

import MissionDatatableController from "./mission_datatable_controller"
application.register("mission-datatable", MissionDatatableController)

import DependencyHighlightController from "./dependency_highlight_controller"
application.register("dependency-highlight", DependencyHighlightController)

import DraggableController from "./draggable_controller"
application.register("draggable", DraggableController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import GanttController from "./gantt_controller"
application.register("gantt", GanttController)

import EchartsController from "./echarts_controller"
application.register("echarts", EchartsController)

import EntryFiltersController from "./entry_filters_controller"
application.register("entry-filters", EntryFiltersController)

import KanbanGlobalController from "./kanban_global_controller"
application.register("kanban-global", KanbanGlobalController)

import LetterFilesController from "./letter_files_controller"
application.register('letter-files', LetterFilesController)

import Lightbox from "./lightbox_controller"
application.register('lightbox', Lightbox)

import LinkForComment from "./link_for_comment_controller"
application.register('link-for-comment', LinkForComment)

import LinkedFiltersController from "./linked_filters_controller"
application.register('linked-filters', LinkedFiltersController)

import DropzoneController from "@kanety/stimulus-dropzone"
application.register("dropzone", DropzoneController)

import LazyFrameController from "./lazy_frame_controller"
application.register("lazy-frame", LazyFrameController)

import MissionResponsiblesController from "./mission_responsibles_controller"
application.register("mission-responsibles", MissionResponsiblesController)

import MissionsCalendarController from "./missions_calendar_controller"
application.register("missions-calendar", MissionsCalendarController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalTriggerController from "./modal_trigger_controller"
application.register("modal-trigger", ModalTriggerController)

import MultiUploadController from "./multi_upload_controller"
application.register("multi-upload", MultiUploadController)

import MultiselectController from "./multiselect_controller"
application.register("multiselect", MultiselectController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import ParticipantFormController from "./participant_form_controller"
application.register("participant-form", ParticipantFormController)

import ParentSelectController from "./parent_select_controller"
application.register("parent-select", ParentSelectController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)

import ProcessedTasksController from "./processed_tasks_controller"
application.register("processed-tasks", ProcessedTasksController)

import RailsNestedForm from '@stimulus-components/rails-nested-form';
application.register('nested-form', RailsNestedForm)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import RefreshController from "./refresh_controller"
application.register("refresh", RefreshController)

import RelatedCacheController from "./related_cache_controller"
application.register("related-cache", RelatedCacheController)

import RichEditorController from "./rich_editor_controller"
application.register("rich-editor", RichEditorController)

import SelectFieldsController from "./select_fields_controller"
application.register("select-fields", SelectFieldsController)

import SideMenuController from "./side_menu_controller"
application.register("side-menu", SideMenuController)

import SortableController from './sortable_controller'
application.register("sortable", SortableController)

import SpoilerController from "./spoiler_controller"
application.register("spoiler", SpoilerController)

import SubmitOnEnterController from "./submit_on_enter_controller"
application.register("submit-on-enter", SubmitOnEnterController)

import SubtreeController from "./subtree_controller"
application.register("subtree", SubtreeController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TableRowController from "./table_row_controller"
application.register("table-row", TableRowController)

import TimeCounterController from "./time_counter_controller"
application.register("time-counter", TimeCounterController)

import TimelogsCalendarController from "./timelogs_calendar_controller"
application.register("timelogs-calendar", TimelogsCalendarController)

import TimePresetController from "./time_preset_controller"
application.register("time-preset", TimePresetController)

import ToggleContentController from "./toggle_content_controller"
application.register("toggle-content", ToggleContentController)

import ToggleFormController from "./toggle_form_controller"
application.register("toggle-form", ToggleFormController)

import TreeSelectController from "./tree_select_controller"
application.register("tree-select", TreeSelectController)

import TrafficLightController from "./traffic_light_controller"
application.register("traffic-light", TrafficLightController)

import UserSelectController from "./user_select_controller";
application.register("user-select", UserSelectController);

import VisibleController from "./visible_controller";
application.register("visible", VisibleController);
